import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useBrands } from "@/contexts/BrandContext";
import { ScoreBadge } from "@/components/app/ScoreBadge";

export default function ClusterDashboard() {
  const { selectedBrandId } = useBrands();
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!selectedBrandId) return;
    api.get(`/dashboard/clusters?brand_id=${selectedBrandId}`).then((r) => setItems(r.data || []));
  }, [selectedBrandId]);

  return (
    <div className="space-y-6">
      <div>
        <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Intelligence</p>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">Keyword Cluster Dashboard</h1>
        <p className="mt-1 text-sm text-slate-500">Demand, opportunity & top keywords per cluster from the latest upload.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="cluster-dashboard-grid">
        {items.map((c, idx) => (
          <div key={`${c.cluster_name}-${idx}`} className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm hover:shadow-md transition-all">
            <div className="flex items-start justify-between">
              <div>
                <span className="text-[11px] uppercase tracking-widest text-slate-500">Cluster</span>
                <h3 className="mt-0.5 text-base font-semibold tracking-tight text-slate-900">{c.cluster_name}</h3>
              </div>
              <ScoreBadge score={c.avg_opportunity} label="OS" />
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2 text-[11px]">
              <Stat label="Keywords" value={c.count} />
              <Stat label="Avg rank" value={c.avg_rank?.toLocaleString() || "—"} />
              <Stat label="Demand" value={c.avg_demand} />
            </div>
            <div className="mt-4">
              <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-1.5">Top keywords</div>
              <ul className="space-y-1">
                {(c.top_keywords || []).map((k, i) => (
                  <li key={i} className="flex items-center justify-between text-xs">
                    <span className="text-slate-700 truncate pr-2">{k.term}</span>
                    <ScoreBadge score={k.opportunity} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
        {!items.length && <div className="text-sm text-slate-500">No clusters yet — upload a CSV first.</div>}
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="rounded-lg bg-slate-50 px-2 py-1.5">
      <div className="text-[10px] uppercase tracking-widest text-slate-400">{label}</div>
      <div className="text-sm font-semibold text-slate-900">{value}</div>
    </div>
  );
}
